export const monsterAreaList = [
  1, // Rogue Encampment
  2, // Blood Moor
  8, // Den of Evil
  3, // Cold Plains
  9, // Cave Level 1
  13, // Cave Level 2
  17, // Burial Grounds
  18, // Crypt
  19, // Mausoleum
  4, // Stony Field
  38, // Tristram
  10, // Underground Passage Level 1
  14, // Underground Passage Level 2
  5, // Dark Wood
  6, // Black Marsh
  11, // Hole Level 1
  15, // Hole Level 2
  20, // Forgotten Tower
  21, // Tower Cellar Level 1
  22, // Tower Cellar Level 2
  23, // Tower Cellar Level 3
  24, // Tower Cellar Level 4
  25, // Tower Cellar Level 5
  7, // Tamoe Highland
  12, // Pit Level 1
  16, // Pit Level 2
  26, // Monastery Gate
  27, // Outer Cloister
  28, // Barracks
  29, // Jail Level 1
  30, // Jail Level 2
  31, // Jail Level 3
  32, // Inner Cloister
  33, // Cathedral
  34, // Catacombs Level 1
  35, // Catacombs Level 2
  36, // Catacombs Level 3
  37, // Catacombs Level 4
  39, // The Secret Cow Level

  40, // Lut Gholein
  47, // Sewers Level 1
  48, // Sewers Level 2
  49, // Sewers Level 3
  41, // Rocky Waste
  55, // Stony Tomb Level 1
  59, // Stony Tomb Level 2
  42, // Dry Hills
  56, // Halls of the Dead Level 1
  57, // Halls of the Dead Level 2
  60, // Halls of the Dead Level 3
  43, // Far Oasis
  62, // Maggot Lair Level 1
  63, // Maggot Lair Level 2
  64, // Maggot Lair Level 3
  44, // Lost City
  65, // Ancient Tunnels
  45, // Valley of Snakes
  58, // Claw Viper Temple Level 1
  61, // Claw Viper Temple Level 2
  50, // Harem Level 1
  51, // Harem Level 2
  52, // Palace Cellar Level 1
  53, // Palace Cellar Level 2
  54, // Palace Cellar Level 3
  74, // Arcane Sanctuary
  46, // Canyon of the Magi
  66, // Tal Rasha's Tomb
  73, // Tal Rasha's Chamber

  75, // Kurast Docks
  76, // Spider Forest
  84, // Arachnid Lair
  85, // Spider Cavern
  77, // Great Marsh
  78, // Flayer Jungle
  86, // Swampy Pit Level 1
  87, // Swampy Pit Level 2
  90, // Swampy Pit Level 3
  88, // Flayer Dungeon Level 1
  89, // Flayer Dungeon Level 2
  91, // Flayer Dungeon Level 3
  79, // Lower Kurast
  80, // Kurast Bazaar
  92, // Sewers Level 1
  93, // Sewers Level 2
  94, // Ruined Temple
  95, // Disused Fane
  81, // Upper Kurast
  96, // Forgotten Reliquary
  97, // Forgotten Temple
  82, // Kurast Causeway
  98, // Ruined Fane
  99, // Disused Reliquary
  83, // Travincal
  100, // Durance of Hate Level 1
  101, // Durance of Hate Level 2
  102, // Durance of Hate Level 3

  103, // The Pandemonium Fortress
  104, // Outer Steppes
  105, // Plains of Despair
  106, // City of the Damned
  107, // River of Flame
  108, // The Chaos Sanctuary

  109, // Harrogath
  110, // Bloody Foothills
  111, // Frigid Highlands
  125, // Abaddon
  112, // Arreat Plateau
  126, // Pit of Acheron
  113, // Crystalline Passage
  114, // Frozen River
  115, // Glacial Trail
  116, // Drifter Cavern
  117, // Frozen Tundra
  127, // Infernal Pit
  118, // The Ancients' Way
  119, // Icy Cellar
  120, // Arreat Summit
  121, // Nihlathak's Temple
  122, // Halls of Anguish
  123, // Halls of Pain
  124, // Halls of Vaught
  128, // Worldstone Keep Level 1
  129, // Worldstone Keep Level 2
  130, // Worldstone Keep Level 3
  131, // Throne of Destruction
  132, // The Worldstone Chamber
  133, // Matron's Den
  134, // Forgotten Sands
  135, // Furnace of Pain
  136, // Tristram
];

export const terrorZoneList = [
  2, // Blood Moor
  8, // Den of Evil
  3, // Cold Plains
  9, // Cave Level 1
  13, // Cave Level 2
  17, // Burial Grounds
  18, // Crypt
  19, // Mausoleum
  4, // Stony Field
  38, // Tristram
  5, // Dark Wood
  21, // Tower Cellar Level 1
  22, // Tower Cellar Level 2
  23, // Tower Cellar Level 3
  24, // Tower Cellar Level 4
  25, // Tower Cellar Level 5
  12, // Pit Level 1
  16, // Pit Level 2
  29, // Jail Level 1
  30, // Jail Level 2
  31, // Jail Level 3
  33, // Cathedral
  34, // Catacombs Level 1
  35, // Catacombs Level 2
  36, // Catacombs Level 3
  37, // Catacombs Level 4
  39, // The Secret Cow Level

  47, // Sewers Level 1
  48, // Sewers Level 2
  49, // Sewers Level 3
  41, // Rocky Waste
  55, // Stony Tomb Level 1
  59, // Stony Tomb Level 2
  42, // Dry Hills
  56, // Halls of the Dead Level 1
  57, // Halls of the Dead Level 2
  60, // Halls of the Dead Level 3
  43, // Far Oasis
  44, // Lost City
  45, // Valley of Snakes
  58, // Claw Viper Temple Level 1
  61, // Claw Viper Temple Level 2
  74, // Arcane Sanctuary
  66, // Tal Rasha's Tomb
  73, // Tal Rasha's Chamber

  76, // Spider Forest
  85, // Spider Cavern
  78, // Flayer Jungle
  88, // Flayer Dungeon Level 1
  89, // Flayer Dungeon Level 2
  91, // Flayer Dungeon Level 3
  80, // Kurast Bazaar
  92, // Sewers Level 1
  93, // Sewers Level 2
  94, // Ruined Temple
  95, // Disused Fane
  83, // Travincal
  100, // Durance of Hate Level 1
  101, // Durance of Hate Level 2
  102, // Durance of Hate Level 3

  104, // Outer Steppes
  105, // Plains of Despair
  106, // City of the Damned
  107, // River of Flame
  108, // The Chaos Sanctuary

  110, // Bloody Foothills
  111, // Frigid Highlands
  112, // Arreat Plateau
  113, // Crystalline Passage
  114, // Frozen River
  115, // Glacial Trail
  118, // The Ancients' Way
  119, // Icy Cellar
  121, // Nihlathak's Temple
  122, // Halls of Anguish
  123, // Halls of Pain
  124, // Halls of Vaught
  128, // Worldstone Keep Level 1
  129, // Worldstone Keep Level 2
  130, // Worldstone Keep Level 3
  131, // Throne of Destruction
  132, // The Worldstone Chamber
];

export const uniqueMonsterAuras = {
  98: {divide: 6}, // Might
  102: {divide: 6}, // Holy Fire
  108: {divide: 5}, // Blessed Aim
  114: {divide: 7}, // Holy Freeze
  118: {divide: 8, min: 20}, // Holy Shock
  122: {divide: 8}, // Fanaticism
  123: {divide: 8}, // Conviction
};

export const monsterUniqueList = {
  40: {area: 8}, // Corpsefire, 
  0: {area: 3}, // Bishibosh
  2: {area: 9}, // Coldcrow
  1: {area: 18}, // Bonebreak
  3: {area: 4}, // Rakanishu, Stony Field
  4: {area: 5}, // Treehead Woodfist, Dark Wood
  6: {area: 25}, // The Countess, Tower Cellar Level 5
  20: {area: 28}, // The Smith, Barracks
  7: {area: 30}, // Pitspawn Fouldog, Jail Level 2
  9: {area: 33}, // Bone Ash, Cathedral
  39: {area: 39}, // The Cow King, Moo Moo Farm
  // Act 2
  14: {area: 59}, // Creeping Feature, Stony Tomb Level 2
  11: {area: 60}, // Bloodwitch the Wild, Halls of the Dead Level 3
  13: {area: 43}, // Beetleburst, Far Oasis
  15: {area: 64}, // Coldworm the Burrower, Maggot Lair Level 3
  17: {area: 44}, // Dark Elder, Lost City
  12: {area: 61}, // Fangskin, Claw Viper Temple Level 2
  16: {area: 54}, // Fire Eye, Palace Cellar Level 3
  19: {area: 66}, // Ancient Kaa the Soulless, Tal Rasha's Tomb
  // Act 3
  21: {area: 85}, // Sszark the Burning, Spider Cavern
  23: {area: 78}, // Stormtree, Flayer Jungle
  22: {area: 91}, // Witch Doctor Endugu, Flayer Dungeon Level 3
  24: {area: 94}, // Battlemaid Sarina, Ruined Temple
  25: {area: 92}, // Icehawk Riftwing, Sewers Level 1
  27: {area: 83}, // Geleb Flamefinger, Travincal
  26: {area: 83}, // Ismail Vilehand, Travincal
  29: {area: 83}, // Toorc Icefist, Travincal
  28: {area: 102}, // Bremm Sparkfist, Durance of Hate Level 3
  31: {area: 102}, // Maffer Dragonhand, Durance of Hate Level 3
  30: {area: 102}, // Wyand Voidbringer, Durance of Hate Level 3
  // Act 4
  41: {area: 107}, // Hephasto the Armorer, River of Flame
  38: {area: 108}, // Grand Vizier of Chaos, Chaos Sanctuary
  36: {area: 108}, // Infector of Souls, Chaos Sanctuary
  37: {area: 108, aura: 122}, // Lord De Seis, Chaos Sanctuary
  // Act 5
  48: {area: 110}, // Dac Farren, Bloody Foothills
  42: {area: 110}, // Shenk the Overseer, Bloody Foothills
  49: {area: 111}, // Eldritch the Rectifier, Frigid Highlands
  56: {area: 111}, // Sharptooth Slayer, Frigid Highlands
  50: {area: 111}, // Eyeback the Unleashed, Frigid Highlands
  51: {area: 112}, // Thresh Socket, Arreat Plateau
  59: {area: 114}, // Frozenstein, Frozen River
  47: {area: 115}, // Bonesaw Breaker, Glacial Trail
  52: {area: 121}, // Pindleskin, Nihlathak's Temple
  53: {area: 119}, // Snapchip Shatter, Icy Cellar
  43: {area: 120}, // Talic, Arreat Summit
  44: {area: 120}, // Madawc, Arreat Summit
  45: {area: 120}, // Korlic, Arreat Summit
  61: {area: 131}, // Colenzo the Annihilator, Throne of Destruction
  62: {area: 131}, // Achmel the Cursed, Throne of Destruction
  63: {area: 131}, // Bartuc the Bloody, Throne of Destruction
  64: {area: 131}, // Ventar the Unholy, Throne of Destruction
  65: {area: 131}, // Lister the Tormentor, Throne of Destruction
};

export const monsterBossList = {
  bloodraven: {area: 17}, // Blood Raven, Burial Grounds
  griswold: {unique: 5, area: 38}, // Griswold, Tristram
  radament: {unique: 10, area: 49}, // Radament, Sewers Level 3
  summoner: {area: 74}, // The Summoner, Arcane Sanctuary
  izual: {area: 105}, // Izual, Plains of Despair
  nihlathakboss: {unique: 60, area: 124}, // Nihlatak, Halls of Vaught

  andariel: {area: 37}, // Andariel, Catacombs Level 4
  duriel: {area: 73}, // Duriel, Tal Rasha's Chamber
  mephisto: {area: 102}, // Mephisto, Durance of Hate Level 3
  diablo: {area: 108}, // Diablo, The Chaos Sanctuary
  baalcrab: {area: 132}, // Baal, The Worldstone Chamber

  diabloclone: {area: 2}, // Diablo Clone

  ubermephisto: {area: 136, mods: ['fast', 'lightning', 'resist', 'aura'], aura: 123, auralevel: 20}, // Uber Mephisto, Tristram
  uberdiablo: {area: 136, mods: ['fast', 'resist']}, // Uber Diablo, Tristram
  uberbaal: {area: 136, mods: ['fast', 'cold', 'resist']}, // Uber Baal, Tristram
  uberandariel: {area: 133, mods: ['fast', 'multishot', 'poisonhit']}, // Lilith, Matron's Den
  uberduriel: {area: 134, mods: ['fast', 'cold']}, // Uber Duriel, Forgotten Sands
  uberizual: {area: 135, mods: ['fast', 'cold']}, // Uber Izual, Furnace of Pain
};

export const extraMonsterList = {
  9: ['fallenshaman1'], // Cave Level 1
  4: ['fallen2', 'fallenshaman1'], // Stony Field
  10: ['fallenshaman1'], // Underground Passage Level 1
  14: ['fallenshaman1'], // Underground Passage Level 2
  5: ['fallenshaman2'], // Dark Wood
  11: ['fallenshaman2'], // Hole Level 1
  15: ['fallenshaman2'], // Hole Level 2
  7: ['fallen3', 'fallenshaman2'], // Tamoe Highland
  12: ['fallenshaman3'], // Pit Level 1
  16: ['fallenshaman3'], // Pit Level 2
  29: ['gargoyletrap'], // Jail Level 1
  30: ['gargoyletrap'], // Jail Level 2
  31: ['gargoyletrap'], // Jail Level 3
  34: ['gargoyletrap'], // Catacombs Level 1
  35: ['gargoyletrap'], // Catacombs Level 2
  36: ['gargoyletrap'], // Catacombs Level 3
  37: ['fallenshaman4'], // Catacombs Level 4

  49: ['skeleton5'], // Sewers Level 3
  56: ['sarcophagus', 'firetower'], // Halls of the Dead Level 1
  57: ['sarcophagus', 'firetower'], // Halls of the Dead Level 2
  60: ['sarcophagus', 'firetower'], // Halls of the Dead Level 3
  44: ['firetower'], // Lost City
  45: ['_', 'firetower'], // Valley of Snakes
  58: ['sarcophagus'], // Claw Viper Temple Level 1
  74: ['lightningspire'], // Arcane Sanctuary
  66: ['sarcophagus', 'firetower'], // Tal Rasha's Tomb
  73: ['_'], // Tal Rasha's Chamber

  77: ['tentaclehead2'], // Great Marsh
  86: ['tentaclehead1'], // Swampy Pit Level 1
  87: ['tentaclehead1'], // Swampy Pit Level 2
  88: ['tentaclehead1'], // Flayer Dungeon Level 1
  89: ['tentaclehead1'], // Flayer Dungeon Level 2
  92: ['tentaclehead3'], // Sewers Level 1
  93: ['tentaclehead3'], // Sewers Level 2
  83: ['tentaclehead1'], // Travincal

  104: ['trappedsoul1', 'trappedsoul2'], // Outer Steppes
  105: ['trappedsoul1', 'trappedsoul2'], // Plains of Despair
  106: ['trappedsoul1', 'trappedsoul2'], // City of the Damned

  110: ['catapult2'], // Bloody Foothills
  111: ['catapult1', 'catapult2', 'barricadetower', 'evilhut', 'barricadedoor1', 'barricadedoor2', 'prisondoor', 'barricadewall1', 'barricadewall2'], // Frigid Highlands
  112: ['catapult1', 'catapult2', 'barricadetower', 'evilhut', 'barricadedoor1', 'barricadedoor2', 'barricadewall1', 'barricadewall2'], // Arreat Plateau
  117: ['catapult1', 'catapult2', 'barricadetower', 'barricadedoor1', 'barricadedoor2', 'barricadewall1', 'barricadewall2'], // Frozen Tundra
  120: ['_'], // Arreat Summit
  121: ['reanimatedhorde3'], // Nihlathak's Temple
  /*
  127, // Infernal Pit
  118, // The Ancients' Way
  119, // Icy Cellar
  122, // Halls of Anguish
  123, // Halls of Pain
  124, // Halls of Vaught
  128, // Worldstone Keep Level 1
  129, // Worldstone Keep Level 2
  130, // Worldstone Keep Level 3
  131, // Throne of Destruction
  132, // The Worldstone Chamber
  133, // Matron's Den
  134, // Forgotten Sands
  135, // Furnace of Pain
  136, // Tristram
*/
};
